import React from 'react';
import { LucideIcon } from 'lucide-react';

interface StatCardProps {
  label: string;
  value: string | number;
  trend?: { value: number; direction: 'up' | 'down' };
  icon?: LucideIcon;
  accent?: 'blue' | 'green' | 'purple' | 'neutral';
}

const accentColors = {
  blue: { bg: 'var(--blue-100)', text: 'var(--blue-700)' },
  green: { bg: 'var(--green-100)', text: 'var(--green-900)' },
  purple: { bg: 'var(--purple-50)', text: 'var(--purple-900)' },
  neutral: { bg: 'var(--neutral-200)', text: 'var(--neutral-700)' },
};

export const StatCard: React.FC<StatCardProps> = ({
  label,
  value,
  trend,
  icon: Icon,
  accent = 'blue',
}) => {
  return (
    <div
      style={{
        background: 'var(--neutral-100)',
        border: '1px solid var(--neutral-300)',
        borderRadius: 'var(--radius-lg)',
        padding: 20,
        display: 'flex',
        flexDirection: 'column',
        gap: 12,
      }}
    >
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
        <span style={{ fontSize: 13, color: 'var(--neutral-500)', fontWeight: 500 }}>
          {label}
        </span>
        {Icon && (
            <div
                style={{
                width: 36,
                height: 36,
                borderRadius: 'var(--radius-md)',
                background: accentColors[accent].bg,
                color: accentColors[accent].text,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
            }}
                >
            <Icon size={18} />
            </div>
            )}
      </div>
      <div style={{ display: 'flex', alignItems: 'baseline', gap: 12 }}>
        <span style={{ fontSize: 28, fontWeight: 700, color: 'var(--neutral-800)' }}>
          {value}
        </span>
        {trend && (
          <span
            style={{
              fontSize: 13,
              fontWeight: 600,
              color: trend.direction === 'up' ? 'var(--green-600)' : 'var(--danger-600)',
            }}
          >
            {trend.direction === 'up' ? '↑' : '↓'} {trend.value}%
          </span>
        )}
      </div>
    </div>
  );
};